<template>
  <!-- Scoreboard Button -->
  <button class="scoreboard-btn" @click="toggleScoreboard">Scoreboard</button>

  <!-- Scoreboard Modal -->
  <div v-if="scoreboardOpen" class="scoreboard-modal">
    <div id="close-scoreboard" @click="toggleScoreboard"></div>
    <div class="scoreboard-content">
      <h3>Scoreboard</h3>
      <table>
        <thead>
          <tr>
            <th>Player</th>
            <th>Points</th>
            <th>Kleine speler</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(player, playerId) in players" :key="playerId">
            <td v-if="player && (player.userName || player.userName === '')">
              {{ player.userName }}
            </td>
            <td v-if="player && (player.points || player.points === 0)">
              {{ player.points }}
            </td>
            <td
              v-if="
                player && (player.kleineSpeler || player.kleineSpeler === 0)
              "
            >
              {{ player.kleineSpeler }}
            </td>
          </tr>
        </tbody>
      </table>
      <button class="close-scoreboard" @click="toggleScoreboard">Close</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ScoreBoard',
  props: {
    players: Object,
  },
  data() {
    return {
      scoreboardOpen: false,
    }
  },
  methods: {
    toggleScoreboard() {
      this.scoreboardOpen = !this.scoreboardOpen
    },
  },
}
</script>

<style scoped>
/* Scoreboard Button */
.scoreboard-btn {
  position: absolute;
  top: 0.5rem;
  right: 2.5rem;
  padding: 6px 12px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-weight: bold;
  transition: background 0.2s ease-in-out;
  z-index: 2;
  width: 6rem;
}

.scoreboard-btn:hover {
  background: #0056b3;
}

/* Scoreboard Modal */
.scoreboard-modal {
  position: fixed;
  display: flex;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  text-align: center;
  justify-content: center;
  align-items: center;
}

.scoreboard-content {
  padding: 2rem;
  border-radius: 20px;
  background: rgba(0, 0, 0, 0.71);
  max-width: 80%;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 200;
}

.scoreboard-content h3 {
  margin-bottom: 10px;
}

.scoreboard-content table {
  width: 100%;
  border-collapse: collapse;
}

.scoreboard-content th,
.scoreboard-content td {
  padding: 8px;
  border-bottom: 1px solid #ccc;
}

.scoreboard-content th {
  background: #222;
}

.close-scoreboard {
  margin-top: 10px;
  background: #ff4d4d;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 5px;
  cursor: pointer;
  font-weight: bold;
}

.close-scoreboard:hover {
  background: #ff1a1a;
}

#close-scoreboard {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
</style>